import React, { useEffect, useRef } from "react";
import { ANIMATIONS } from "../utils/animations";

export default function AnimationPreviewCanvas({ animation, img }) {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);
  const startRef = useRef(null);

  useEffect(() => {
    if (!img || !animation) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const duration = 2; // 2s preview loop

    const loop = (ts) => {
      if (!startRef.current) startRef.current = ts;
      const elapsed = (ts - startRef.current) / 1000;
      const p = (elapsed % duration) / duration; // 0 → 1 loop

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const fn = ANIMATIONS[animation];
      if (fn) {
        fn(ctx, img, p, canvas);
      } else {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      }

      rafRef.current = requestAnimationFrame(loop);
    };

    rafRef.current = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
      startRef.current = null;
    };
  }, [animation, img]);

return (
  <canvas
    ref={canvasRef}
    width={120}
    height={70}
    className="
      rounded
      bg-black
      border border-gray-300 dark:border-gray-700
    "
  />
);

}
